import React from 'react'
import PropTypes from 'prop-types'

function EconomyCardText ({ children, title }) {
  return (
    <div>
      <div className='font-medium text-sm'>
        {children}
      </div>
      <div className='text-xs text-gray-500 mt-1'>
        {title}
      </div>
    </div>
  )
}

export default EconomyCardText
